import React, { Component } from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import Helmet from 'react-helmet';
import _ from 'lodash';
import moment from 'moment';
import { hide } from '@intercom/messenger-js-sdk';

import Loading from '../../components/Loading/Loading';
import { selectDashboard, setWallboardDashboard } from '../../components/DashboardSelector/DashboardSelectorActions';

import { setChart, initFilters as getFilterValues } from '../../components/Filter/FilterActions';
import { getSetting } from '../Wallboards/WallboardsActions';

import { getData as getOverviewData } from '../Overview/OverviewActions';
import Overview from '../Overview/pages/WallboardOverview';

import { getData as getCfdData } from '../CFD/CFDActions';
import CFDChart from '../CFD/components/WallboardCFDChart';

import { getData as getCtspData } from '../CycleTimeScatterPlot/CTSPActions';
import CTSPChart from '../CycleTimeScatterPlot/components/WallboardCTSPChart';

import { getData as getCtbData } from '../CycleTimeBreakdown/CTBActions';
import CTBChart from '../CycleTimeBreakdown/components/WallboardCTBChart';

import { getData as getCthData } from '../CycleTimeHistogram/CTHActions';
import CTHChart from '../CycleTimeHistogram/components/WallboardCTHChart';

import { getData as getCtaData } from '../CycleTimeAging/CTAActions';
import CTAChart from '../CycleTimeAging/components/WallboardCTAChart';

import { getData as getTrcData } from '../Throughput/ThroughputActions';
import TRCChart from '../Throughput/components/WallboardThroughputChart';

import { getData as getThData } from '../ThroughputHistogram/ThroughputHistogramActions';
import THChart from '../ThroughputHistogram/components/WallboardThroughputHistogramChart';

import { getData as getFEData } from '../FlowEfficiency/FlowEfficiencyActions';
import FEChart from '../FlowEfficiency/components/WallboardFlowEfficiencyChart';

import { getData as getDDPData, getOnTimeData } from '../DueDatePerformance/DueDatePerformanceActions';
import DDPChart from '../DueDatePerformance/components/WallboardDDPChart';

import { getData as getMCDeliveryData } from '../MonteCarlo/MonteCarloActions';
import MCDeliveryChart from '../MonteCarlo/components/WallboardMonteCarloChart';

import { getData as getMCTasksData } from '../MonteCarloTasks/MonteCarloTasksActions';
import MCTasksChart from '../MonteCarloTasks/components/WallboardMonteCarloTasksChart';

import './Wallboard.scss';

class Wallboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settingsReady: false,
      charts: {},
      settings: {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: false,
        swipeToSlide: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        pauseOnHover: false
      }
    };
  }

  componentDidMount() {
    this.props.getSetting(this.props.routeParams.id);

    if (this.props.setting) {
      this.setSettings();
    }

    if (global.window) {
      hide();
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.setting, this.props.setting)) {
      this.setSettings();
    }

    if (this.props.allDashboards.length && !_.isEqual(prevProps.allDashboards, this.props.allDashboards)) {
      this.setDashboard();
    }

    if (prevProps.dataHash != this.props.dataHash) {
      if (this.props.user && this.props.user.config && this.props.user.config.enableDoneFilters) {
        this.props.getFilterValues();
      } else {
        this.props.getFilterValues({ done: true });
      }
      this.props.dispatch(setChart('wallmode'));
    }

    if (
      (prevProps.dataHash != this.props.dataHash || prevProps.dashboard != this.props.dashboard) &&
      this.props.dataIsLoading === false
    ) {
      this.getData();
    }
  }

  setSettings() {
    const interval = this.props.setting.rotationInterval * 1000;
    const { from, to } = this.props.location.query;
    const customFilters = [];
    _.forEach(this.props.location.query, (v, k) => {
      if (k == 'from' || k == 'to') return;

      customFilters.push({
        name: k,
        values: v.split(',')
      });
    });

    const customDates = {};
    if (from && moment(from)._isValid) {
      customDates.from = moment(from).toISOString();
    }
    if (to && moment(to)._isValid) {
      customDates.to = moment(to).toISOString();
    }

    this.setState(
      {
        customFilters,
        customDates,
        settingsReady: true,
        settings: {
          ...this.state.settings,
          fade: true,
          autoplaySpeed: interval,
          autoplay: !!interval
        },
        chartConfig: this.props.setting.chartConfig,
        globalConfig: this.props.setting.globalConfig,
        charts: this.props.setting.enabledCharts
      },
      this.setDashboard
    );
  }

  setDashboard() {
    let dashboard = _.find(this.props.allDashboards, b => b._id == this.props.setting.boardId);
    if (dashboard) {
      dashboard = { ...dashboard };
      if (this.props.setting.selectedView !== 'default') {
        if (this.state.globalConfig) {
          dashboard.globalConfig = this.state.globalConfig;
        }
        if (this.state.chartConfig) {
          dashboard.chartConfig = this.state.chartConfig;
        }
      }

      const { from, to } = this.state.customDates;
      if (from && to) {
        dashboard.globalConfig.from = from;
        dashboard.globalConfig.to = to;
        dashboard.globalConfig.customDate = true;
      }
      if (this.state.customFilters) {
        dashboard.customFilters = this.state.customFilters;
      }

      this.props.selectDashboard(dashboard);
    } else if (this.props.setting.boardId) {
      this.props.setWallboardDashboard(this.props.setting.boardId);
    }
  }

  getData() {
    const { charts } = this.state;
    if (!this.props.dataIsLoading) {
      setTimeout(() => {
        !!charts.overview && this.props.dispatch(getOverviewData());
        !!charts.cfd && this.props.dispatch(getCfdData());
        !!charts.ctsp && this.props.dispatch(getCtspData());
        !!charts.ctb && this.props.dispatch(getCtbData());
        !!charts.cth && this.props.dispatch(getCthData());
        !!charts.cta && this.props.dispatch(getCtaData(true));
        !!charts.trc && this.props.dispatch(getTrcData());
        !!charts.th && this.props.dispatch(getThData());
        !!charts.fe && this.props.dispatch(getFEData());
        !!charts.ddp && this.props.dispatch(getDDPData());
        !!charts.ddp && this.props.dispatch(getOnTimeData());
        !!charts.mc && this.props.dispatch(getMCDeliveryData());
        !!charts.mct && this.props.dispatch(getMCTasksData());
      });
    }
  }

  render() {
    const { settings, settingsReady, charts } = this.state;

    return (
      <div className="content-wrap">
        <Helmet
          title={`Wallboard${
            this.props.dashboard ? ' | ' + (this.props.dashboard.label || this.props.dashboard.name) : ''
          }`}
        />
        <div className="wallboard_container">
          {(this.props.dataIsLoading || !this.props.data.activities || this.props.wallIsLoading) && <Loading />}
          {!this.props.dataIsLoading && this.props.data.activities && !this.props.wallIsLoading && settingsReady && (
            <Slider {...settings}>
              {!!charts.overview && <Overview />}
              {!!charts.cfd && <CFDChart />}
              {!!charts.ctsp && <CTSPChart />}
              {!!charts.ctb && <CTBChart />}
              {!!charts.cth && <CTHChart />}
              {!!charts.cta && <CTAChart />}
              {!!charts.trc && <TRCChart />}
              {!!charts.th && <THChart />}
              {!!charts.fe && <FEChart />}
              {!!charts.ddp && <DDPChart />}
              {!!charts.mc && <MCDeliveryChart />}
              {!!charts.mct && <MCTasksChart />}
            </Slider>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getFilterValues: (disabled) => dispatch(getFilterValues(disabled)),
    setWallboardDashboard: boardId => dispatch(setWallboardDashboard(boardId)),
    getSetting: wallboardId => dispatch(getSetting(wallboardId)),
    selectDashboard: dashboard => dispatch(selectDashboard(dashboard))
  };
};

const mapStateToProps = state => {
  return {
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    data: state.app.data,
    dashboard: state.dashboards.selected,
    allDashboards: state.dashboards.list,
    setting: state.wallboards.setting,
    dates: state.filters.dates,
    user: state.auth.user,
    wallIsLoading: state.wallboards.isLoading
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Wallboard);
